import { createZodDto } from "nestjs-zod/dto";

import { coverLetterSchema } from "./cover-letter";

export const updateCoverLetterSchema = coverLetterSchema.partial();

export class UpdateCoverLetterDto extends createZodDto(updateCoverLetterSchema) {}
